import { Box, Button, Container, Paper, styled, Typography } from "@mui/material";
import Section from "./Section";
import { useEffect, useState } from "react";
import { SlSocialGoogle } from "react-icons/sl";
import { Google, Microsoft } from "@mui/icons-material";
import { useTranslation } from 'react-i18next';

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: "#00000099",
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '100%',
  letterSpacing: '0%',
   "& p": {
      color: "#00000099",
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '100%',
  letterSpacing: '0%',
    },
    "& strong": {
      fontWeight: 600, 
    }
}));

export default function OfferDetails({ post, scraping }) {
  const { t } = useTranslation();
const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  useEffect(() => {
    if (post) {
      console.log('post is:', post);
    }
  }, [post]);

  if (!post) {
    return (
      <Container
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <Paper
          elevation={2}
          sx={{ p: 3, textAlign: 'center' }}
        >
          <Typography variant="h6" gutterBottom>
            {t('offerDetails.noOfferAvailable')}
          </Typography>
          <Typography>
            {t('offerDetails.tryAgainLater')}
          </Typography>
        </Paper>
      </Container>
    );
  }

  return (
    <Container
      maxWidth={false}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        px: [2, 4],
        backgroundColor: 'transparent',
        marginBottom: 4,
      }}
    >
      <Paper
        sx={{
          maxWidth: 1152,
          borderRadius: 4,
          border: '1px solid #d9d9d9',
          p: [3, 4],
          width: '100%',
        }}
      >
        <StyledTypography
          sx={{
            fontFamily: 'Poppins',
            color: '#000',
            mb: 2,
            fontWeight: 600,
            fontSize: [24, 28]
          }}
          gutterBottom
        >
          {post.title || 'No Title Provided'}
        </StyledTypography>

        <Section title={t('offerDetails.description')}>
          <StyledTypography sx={{
            display: isExpanded ? "block" : "-webkit-box",
          WebkitLineClamp: isExpanded ? "none" : 8,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          }} paragraph dangerouslySetInnerHTML={{ __html: post.description }}>
            {/* <Typography
              variant="body2"
              sx={{
                mb: isMobile ? 1.5 : 2,
                color: "#000000B2",
                fontSize: isMobile ? "11px" : "12px",
                lineHeight: isMobile ? "16px" : "18px",
                fontFamily: "Poppins",
                fontWeight: 400,
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: isMobile ? "48px" : "54px", // Adjusted height for mobile
              }} 
               
               
               
               */}
            {/* > */}
                          

            
            {/* {post.description || t('offerDetails.noRequirements')} */}
          </StyledTypography>
          <Button
        onClick={toggleExpanded}
        sx={{
          mt: -2,
          p: 0,
          minWidth: 'auto',
          color: '#1976d2',
          fontSize: '14px',
          fontFamily: 'Poppins',
          fontWeight: 400,
          textTransform: 'none',
          '&:hover': {
            backgroundColor: 'transparent',
            textDecoration: 'underline',
          }
        }}
      >
        {isExpanded ? t('See_less') : t('See_more')}
      </Button>
        </Section>
        {scraping === '1' && (
          <>
            <Section title={t('offerDetails.reference')}>
              <StyledTypography paragraph>
                {post.reference || t('offerDetails.noReference')}
              </StyledTypography>
            </Section>
            <Section title={t('offerDetails.accountType')}>
              <StyledTypography paragraph sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {post.accountType === 'g' && (
                  <>
                    <Google style={{ color: '#0017e7' }} />
                    Google
                  </>
                )}
                {post.accountType === 'm' && (
                  <>
                    <Microsoft style={{ color: '#0017e7' }} />
                    Microsoft
                  </>
                )}
                {!post.accountType && t('offerDetails.noAccountType')}
              </StyledTypography>
            </Section>
          </>
        )}

        <Section title={t('offerDetails.expirationDate')}>
          <StyledTypography>
            {post.deadline || t('offerDetails.noDeadline')}
          </StyledTypography>
        </Section>

        <Section title={t('offerDetails.requiredSkills')}>
          <StyledTypography>
            {post.requirements && post.requirements.length > 0
              ? post.requirements.join(' - ')
              : t('offerDetails.noSkills')}
          </StyledTypography>
        </Section>

        <Section title={t('offerDetails.salary')}>
          <StyledTypography>
            {post.salary ? `${post.salary} ${t('offerDetails.perMonth')}` : t('offerDetails.salaryNotSpecified')}
          </StyledTypography>
        </Section>

        <Section title={t('offerDetails.offerType')}>
          <StyledTypography>
            {post.offerType === 'j' ? t('offerDetails.job') : t('offerDetails.internship') || t('offerDetails.contractTypeNotSpecified')}
          </StyledTypography>
        </Section>

        <Section title={t('offerDetails.jobType')}>
          <StyledTypography>
            {post.mode || t('offerDetails.jobTypeNotSpecified')}
          </StyledTypography>
        </Section>
      </Paper>
    </Container>
  );
}